import { render, staticRenderFns } from "./PersonSearchBar.vue?vue&type=template&id=319faeee&"
import script from "./PersonSearchBar.vue?vue&type=script&lang=ts&"
export * from "./PersonSearchBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports